/* eslint-disable max-len */
import { ComponentProps } from 'react';
import {
    Popover,
    Text,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { FaIcon, PopoverTag } from '@acp/core-ui';
import { ReportedFindingProperty, ReportedFindingsFacets } from '@acp/shared';
import { faUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';

function QuotationTag({
    tags,
    property,
    popoverPlacement = 'auto',
    ...props
}: {
    tags: string[];
    property: ReportedFindingProperty;
    popoverPlacement?: ComponentProps<typeof Popover>['placement'];
} & ComponentProps<typeof Popover>) {
    const hasNonUrgentQuotes = !tags.includes(ReportedFindingsFacets.AwaitingUrgentQuotationApproval)
        && tags.includes(ReportedFindingsFacets.AwaitingQuotationApproval);
    const hasUrgentQuotes = tags.includes(ReportedFindingsFacets.AwaitingUrgentQuotationApproval)
        && tags.includes(ReportedFindingsFacets.AwaitingQuotationApproval);
    const hasRejectedQuotes = tags.includes(ReportedFindingsFacets.RejectedQuotes);

    return (
        <>
            {hasNonUrgentQuotes && (
                <PopoverTag popoverPlacement={popoverPlacement} colorScheme="blackAlpha" title="Awaiting quotation approval" {...props}>
                    <Text fontSize="small" fontWeight="bold">Awaiting quotation approval</Text>
                    <Text fontSize="small">One or more quotations are awaiting approval to resolve the reported findings. Please review and respond to these.</Text>
                    <Link to={`/property/${property.compliancePropertyId}`}>
                        <Text
                            fontSize="small"
                            fontWeight="bold"
                            textDecoration="underline"
                            _hover={{ textDecoration: 'none' }}
                            mt={1}
                        >
                            View quotations
                            <FaIcon icon={faUpRightFromSquare} ml={1} h={3} />
                        </Text>
                    </Link>
                </PopoverTag>
            )}
            {hasUrgentQuotes && (
                <PopoverTag popoverPlacement={popoverPlacement} colorScheme="blackAlpha" title="Awaiting urgent quotation approval" {...props}>
                    <Text fontSize="small" fontWeight="bold" color="danger.500">Awaiting urgent quotation approval</Text>
                    <Text fontSize="small">One or more quotations are awaiting approval to resolve the urgent reported findings. Please review and respond to these.</Text>
                    <Link to={`/property/${property.compliancePropertyId}`}>
                        <Text
                            fontSize="small"
                            fontWeight="bold"
                            textDecoration="underline"
                            _hover={{ textDecoration: 'none' }}
                            mt={1}
                        >
                            View quotations
                            <FaIcon icon={faUpRightFromSquare} ml={1} h={3} />
                        </Text>
                    </Link>
                </PopoverTag>
            )}
            {hasRejectedQuotes && (
                <PopoverTag popoverPlacement={popoverPlacement} colorScheme="blackAlpha" title="Quotation rejected" {...props}>
                    <Text fontSize="small" fontWeight="bold">Quotation rejected</Text>
                    <Text fontSize="small">One or more quotations are rejected for this reported finding.</Text>
                    <Link to={`/property/${property.compliancePropertyId}`}>
                        <Text
                            fontSize="small"
                            fontWeight="bold"
                            textDecoration="underline"
                            _hover={{ textDecoration: 'none' }}
                            mt={1}
                        >
                            View quotations
                            <FaIcon icon={faUpRightFromSquare} ml={1} h={3} />
                        </Text>
                    </Link>
                </PopoverTag>
            )}
        </>

    );
}

export { QuotationTag };
